export default {
    'name': 'factory',
    'width': '32',
    'height': '32',
    'viewBox': '0 0 32 32',
    'data': '<g clip-path=\'url(#clip0_11939_584)\'><path d=\'M10 22H13.5M18.5 22H22M27 17H21L13 11V17L5 11V27M27 17L25.125 3.85875C25.0909 3.61999 24.9717 3.40158 24.7893 3.24378C24.607 3.08597 24.3737 2.99939 24.1325 3H21.8675C21.6263 2.99939 21.393 3.08597 21.2107 3.24378C21.0283 3.40158 20.9091 3.61999 20.875 3.85875L19.1938 15.645M27 17V27M2 27H30\' stroke=\'#19405B\' stroke-width=\'2\' stroke-linecap=\'round\' stroke-linejoin=\'round\'/></g><defs><clipPath id=\'clip0_11939_584\'><rect width=\'32\' height=\'32\' fill=\'white\'/></clipPath></defs>'
}
